<template>
  <div :class="cGroupClass">
    <div class="fm-form-input" :class="label ? 'mt-2' : ''">
      <label v-if="label" :for="name">
        {{ label }}&nbsp;
        <span v-if="label && required" class="text-red-600">*</span>
      </label>
      <div class="relative">
        <textarea
          :id="id"
          v-model="localModelValue"
          :disabled="disabled || !editionMode"
          :placeholder="placeholder"
          class="block w-full rounded-md px-3 py-2"
          :rows="rows"
        />
        <span
          v-if="editionMode && !disabled"
          class="pointer-events-none absolute right-2 bottom-1 text-xs text-gray-400 select-none"
        >
          {{ (localModelValue || '').replace(/\s/g, '').length }}
        </span>
      </div>
    </div>
    <ErrorContainer :error-key="name" :errors="errors" />
  </div>
</template>

<script>
import ErrorContainer from '@c/addf-package/components/BaseShowEditInput/ErrorContainer.vue'

export default {
  name: 'BaseShowEditTextArea',
  components: { ErrorContainer },
  props: {
    editionMode: {
      type: Boolean,
      default: true
    },
    id: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: '',
      require: true
    },
    modelValue: {
      type: [String, Number],
      default: '',
      require: true
    },
    errors: {
      type: Array,
      default() {
        return []
      }
    },
    groupClass: {
      type: String,
      required: false,
      default: ''
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: [String, Number],
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    rows: {
      type: [String, Number],
      default: 3,
      require: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    cGroupClass() {
      return this.groupClass === '' ? ' w-full' : this.groupClass
    },
    localModelValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
}
</script>
